<template>
  <MainLayout>
    <template v-slot:toolbar>
      <!--begin::Page title-->
      <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
        <!--begin::Title-->
        <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Relatório de campanhas</h1>
        <!--end::Title-->
      </div>
      <!--end::Page title-->
    </template>

    <!-- CONTENT -->
    <!--begin::Products-->
    <div class="card card-flush">
      <!--begin::Card body-->
      <div class="card-body pt-0">
        <div class="text-center py-5">
          <form @submit.prevent="">
            <div class="d-flex mx-md-auto align-items-center justify-content-center mb-5">
              <label class="form-label fw-semibold">Período:</label>
              <DateTimeInput
                v-model.trim="form.start_date"
                format="dd/MM/yyyy"
                type="date"
                theme="basic"
                class="mx-2"
                placeholder="Início"
              />
              <DateTimeInput
                v-model.trim="form.end_date"
                format="dd/MM/yyyy"
                type="date"
                theme="basic"
                class="mx-2"
                placeholder="Término"
              />
            </div>
            <div class="d-flex align-items-center justify-content-center mb-5">
              <label class="form-label fw-semibold me-2">Tipo: </label>
              <div class="">
                <select
                  v-model="form.type"
                  class="form-control"
                >
                  <option value="">Todos</option>
                  <option
                    v-for="type in campaignTypes"
                    :key="type"
                    :value="type"
                  >
                    {{ type | formatCampaignType }}
                  </option>
                </select>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-center mb-5">
              <label class="form-label fw-semibold me-2">Status: </label>
              <div class="custom-select custom-select-sm">
                <div class="form-check form-check-inline mb-1" v-for="type in campaignStatus" :key="type">
                  <input class="form-check-input" type="checkbox" v-model="form.status" :value="type" :id="`flexCheck-${type}`">
                  <label class="form-check-label" :for="`flexCheck-${type}`">
                    {{ type | formatCampaignStatus }}
                  </label>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <Button
                class="btn-primary"
                :loading="loader"
                @click="submit"
              >
                Extrair relatório
              </Button>
            </div>
          </form>
        </div>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::Products-->
    <!-- END CONTENT -->
  </MainLayout>
</template>

<script>

import NotificationService from '@/modules/notifications/services/notifications-service'
import ReportsService from '@/modules/reports/services/reports-service'

import Button from '@/components/common/Button/Button'
import DateTimeInput from '@/components/common/Input/DateTimeInput'
import MainLayout from '@/components/layouts/MainLayout'

export default {
  components: {
    Button,
    DateTimeInput,
    MainLayout
  },
  metaInfo () {
    return {
      title: this.title
    }
  },
  data () {
    return {
      campaignTypes: [
        'PROGRAMMATIC',
        'NATIVE',
        'NATIVE_OPEN',
        'NATIVE_CONTEXTUAL',
        'PUSH',
        'SEARCH',
        'YOUTUBE',
        'META_ADS',
        'AUDIO'
      ],
      campaignStatus: ['ACTIVE', 'FINISHED', 'PAUSED', 'DRAFT', 'PENDING'],
      form: {
        start_date: '',
        end_date: '',
        status: [],
        type: ''
      },
      loader: false
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      try {
        await ReportsService.requestCampaignListReport(this.form)
        const notification = {
          notification: {
            type: 'success',
            content: 'Relatório solicitado com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
